import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";

export default function Completed() {
  const { PopupStore, MockStore } = useStores();
  const navigate = useNavigate();
  return useObserver(() => {
    return (
      <>
        {PopupStore.Mcq && (
          <div className="absolute w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40">
            <div className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded items-center md:w-[60%] lg:w-[60%] w-[90%] h-[75%] md:h-[50%] lg:h-[50%] m-auto shadow-lg overflow-y-auto no-scrollbar">
              <div className="flex flex-col justify-between  h-full py-5 w-[100%] md:w-[100%] lg:[100%] border ">
                <div className=" flex flex-col gap-10 text-2xl justify-center items-center h-full text-primary font-semibold w-[100%]">
                  Your time has been completed Submit your test
                  <button
                    className="bg-primary text-white rounded-xl w-[20%] py-2"
                    onClick={() => {
                      MockStore.getAnswer();
                      MockStore.setTestOnLive(false);
                      MockStore.setQuestionNumber(1);
                      MockStore.setSection("APTITUDE");
                      navigate("/mock-answer");
                    }}
                  >
                    <span>Submit</span>
                  </button>
                </div>
                {/* <div className="absolute right-5 bottom-10"> <button className="text-primary font-bold">Mark all as read</button></div> */}
              </div>
            </div>
          </div>
        )}
      </>
    );
  });
}
